import React from 'react';
import Navigation from '../_components/Navigation';

class NotFoundPage extends React.Component {
    render() {
        return (
            <div>
                <Navigation active=""  authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55">
                    <div className="row">
                        <div className="col-xs-12">
                            <section className="error-404 not-found">
                                <header className="page-header">
                                    <h1 className="page-title">Oops! That page can't be found.</h1>
                                </header>

                                <div className="page-content h3 text-muted padding-tb40">
                                    <p>It looks like nothing was found at this location. <a href="javascript:history.go(-1)">Go back</a>?</p>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { NotFoundPage }; 